/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import isIPad from "$src/core/utils/device/is-ipad";
import CustomPlatform from "$src/core/utils/platform/platform";

// A tablet is closer to the desktop than to the phone, so it takes the web layout.
export default CustomPlatform.select<() => React.FC>({
  tv: () => require("./EPGPage.tv").default,
  web: () => require("./EPGPage.web").default,
  ios: () =>
    isIPad ? require("./EPGPage.web").default : require("./EPGPage").default,
  default: () => require("./EPGPage").default,
})();
